import { useEffect } from "react";
import { useSelector } from "react-redux";

import { selectCurrentFarm } from "src/modules/farms/shared/selectors/farm.selector";

export function useFarmFeatureToggles(): void {
  const currentFarm = useSelector(selectCurrentFarm);

  useEffect(() => {
    if (!currentFarm) {
      return;
    }
    const {
      allowAssetsFromAllFarms,
      allowSeedsFromAllCrops,
      allowTechFromAllTechSubgroups,
    } = currentFarm;

    // TODO: declacre ekocropApi interface in GlobalContext
    window["ekocropApi"].toggleFeature(
      "allowAssetsFromAllFarms",
      allowAssetsFromAllFarms
    );
    window["ekocropApi"].toggleFeature("allowSeedsFromAllCrops", allowSeedsFromAllCrops);
    window["ekocropApi"].toggleFeature(
      "allowTechFromAllTechSubgroups",
      allowTechFromAllTechSubgroups
    );
  }, [currentFarm]);
}
